// extracted by mini-css-extract-plugin
export default {"root":"SavedSearchesList_root__MNvmK","savedSearch":"SavedSearchesList_savedSearch__Ie0sv","empty":"SavedSearchesList_empty__cee1K","loaderBox":"SavedSearchesList_loaderBox__or3ZE"};